/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Ripia API
 * 美容サロン・リラクゼーション業界向け統合管理SaaSシステムAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConfirmationEmailStatusDto,
  CreateShopDto,
  EffectivePlanResponseDto,
  SaveCredentialsDto,
  ShopResponseDto,
  TestCredentialsDto,
  UpdateMyShopDto,
  UpdateShopDto
} from '../../schemas';

import { customInstance } from '../../../lib/custom-instance';




export const shopsControllerCreate = (
    createShopDto: CreateShopDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ShopResponseDto>(
      {url: `/shops`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createShopDto, signal
    },
      );
    }
  


export const getShopsControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerCreate>>, TError,{data: CreateShopDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerCreate>>, TError,{data: CreateShopDto}, TContext> => {

const mutationKey = ['shopsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerCreate>>, {data: CreateShopDto}> = (props) => {
          const {data} = props ?? {};

          return  shopsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerCreate>>>
    export type ShopsControllerCreateMutationBody = CreateShopDto
    export type ShopsControllerCreateMutationError = unknown

    export const useShopsControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerCreate>>, TError,{data: CreateShopDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerCreate>>,
        TError,
        {data: CreateShopDto},
        TContext
      > => {

      const mutationOptions = getShopsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const shopsControllerFindAll = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ShopResponseDto[]>(
      {url: `/shops`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerFindAllQueryKey = () => {
    return [
    `/shops`
    ] as const;
    }

    
export const getShopsControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerFindAll>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerFindAll>>> = ({ signal }) => shopsControllerFindAll(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerFindAll>>>
export type ShopsControllerFindAllQueryError = unknown


export function useShopsControllerFindAll<TData = Awaited<ReturnType<typeof shopsControllerFindAll>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindAll<TData = Awaited<ReturnType<typeof shopsControllerFindAll>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindAll<TData = Awaited<ReturnType<typeof shopsControllerFindAll>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerFindAll<TData = Awaited<ReturnType<typeof shopsControllerFindAll>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerFindMyShop = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ShopResponseDto>(
      {url: `/shops/my`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerFindMyShopQueryKey = () => {
    return [
    `/shops/my`
    ] as const;
    }

    
export const getShopsControllerFindMyShopQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerFindMyShopQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerFindMyShop>>> = ({ signal }) => shopsControllerFindMyShop(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerFindMyShopQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerFindMyShop>>>
export type ShopsControllerFindMyShopQueryError = unknown


export function useShopsControllerFindMyShop<TData = Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindMyShop>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindMyShop>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindMyShop<TData = Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindMyShop>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindMyShop>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindMyShop<TData = Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerFindMyShop<TData = Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShop>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerFindMyShopQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerUpdateMyShop = (
    updateMyShopDto: UpdateMyShopDto,
 ) => {
      
      
      return customInstance<ShopResponseDto>(
      {url: `/shops/my`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMyShopDto
    },
      );
    }
  


export const getShopsControllerUpdateMyShopMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerUpdateMyShop>>, TError,{data: UpdateMyShopDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerUpdateMyShop>>, TError,{data: UpdateMyShopDto}, TContext> => {

const mutationKey = ['shopsControllerUpdateMyShop'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerUpdateMyShop>>, {data: UpdateMyShopDto}> = (props) => {
          const {data} = props ?? {};

          return  shopsControllerUpdateMyShop(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerUpdateMyShopMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerUpdateMyShop>>>
    export type ShopsControllerUpdateMyShopMutationBody = UpdateMyShopDto
    export type ShopsControllerUpdateMyShopMutationError = unknown

    export const useShopsControllerUpdateMyShop = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerUpdateMyShop>>, TError,{data: UpdateMyShopDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerUpdateMyShop>>,
        TError,
        {data: UpdateMyShopDto},
        TContext
      > => {

      const mutationOptions = getShopsControllerUpdateMyShopMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const shopsControllerGetMyEffectivePlan = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EffectivePlanResponseDto>(
      {url: `/shops/me/effective-plan`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerGetMyEffectivePlanQueryKey = () => {
    return [
    `/shops/me/effective-plan`
    ] as const;
    }

    
export const getShopsControllerGetMyEffectivePlanQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerGetMyEffectivePlanQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>> = ({ signal }) => shopsControllerGetMyEffectivePlan(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerGetMyEffectivePlanQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>>
export type ShopsControllerGetMyEffectivePlanQueryError = unknown


export function useShopsControllerGetMyEffectivePlan<TData = Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetMyEffectivePlan<TData = Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetMyEffectivePlan<TData = Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerGetMyEffectivePlan<TData = Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetMyEffectivePlan>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerGetMyEffectivePlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerFindMyShopAlias = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ShopResponseDto>(
      {url: `/shops/mine`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerFindMyShopAliasQueryKey = () => {
    return [
    `/shops/mine`
    ] as const;
    }

    
export const getShopsControllerFindMyShopAliasQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerFindMyShopAliasQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>> = ({ signal }) => shopsControllerFindMyShopAlias(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerFindMyShopAliasQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>>
export type ShopsControllerFindMyShopAliasQueryError = unknown


export function useShopsControllerFindMyShopAlias<TData = Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindMyShopAlias<TData = Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindMyShopAlias<TData = Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerFindMyShopAlias<TData = Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindMyShopAlias>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerFindMyShopAliasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerFindOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerFindOneQueryKey = (id?: string,) => {
    return [
    `/shops/${id}`
    ] as const;
    }

    
export const getShopsControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerFindOne>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerFindOne>>> = ({ signal }) => shopsControllerFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerFindOne>>>
export type ShopsControllerFindOneQueryError = unknown


export function useShopsControllerFindOne<TData = Awaited<ReturnType<typeof shopsControllerFindOne>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindOne<TData = Awaited<ReturnType<typeof shopsControllerFindOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindOne<TData = Awaited<ReturnType<typeof shopsControllerFindOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerFindOne<TData = Awaited<ReturnType<typeof shopsControllerFindOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerUpdate = (
    id: string,
    updateShopDto: UpdateShopDto,
 ) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateShopDto
    },
      );
    }
  


export const getShopsControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerUpdate>>, TError,{id: string;data: UpdateShopDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerUpdate>>, TError,{id: string;data: UpdateShopDto}, TContext> => {

const mutationKey = ['shopsControllerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerUpdate>>, {id: string;data: UpdateShopDto}> = (props) => {
          const {id,data} = props ?? {};

          return  shopsControllerUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerUpdate>>>
    export type ShopsControllerUpdateMutationBody = UpdateShopDto
    export type ShopsControllerUpdateMutationError = unknown

    export const useShopsControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerUpdate>>, TError,{id: string;data: UpdateShopDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerUpdate>>,
        TError,
        {id: string;data: UpdateShopDto},
        TContext
      > => {

      const mutationOptions = getShopsControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const shopsControllerRemove = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getShopsControllerRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerRemove>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['shopsControllerRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  shopsControllerRemove(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerRemove>>>
    
    export type ShopsControllerRemoveMutationError = unknown

    export const useShopsControllerRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerRemove>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getShopsControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const shopsControllerFindByTenantId = (
    tenantId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/shops/tenant/${tenantId}`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerFindByTenantIdQueryKey = (tenantId?: string,) => {
    return [
    `/shops/tenant/${tenantId}`
    ] as const;
    }

    
export const getShopsControllerFindByTenantIdQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError = unknown>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerFindByTenantIdQueryKey(tenantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>> = ({ signal }) => shopsControllerFindByTenantId(tenantId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerFindByTenantIdQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>>
export type ShopsControllerFindByTenantIdQueryError = unknown


export function useShopsControllerFindByTenantId<TData = Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError = unknown>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindByTenantId>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindByTenantId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindByTenantId<TData = Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerFindByTenantId>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerFindByTenantId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerFindByTenantId<TData = Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerFindByTenantId<TData = Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerFindByTenantId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerFindByTenantIdQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerGetOrGenerateReservationEmail = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}/reservation-email`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerGetOrGenerateReservationEmailQueryKey = (id?: string,) => {
    return [
    `/shops/${id}/reservation-email`
    ] as const;
    }

    
export const getShopsControllerGetOrGenerateReservationEmailQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerGetOrGenerateReservationEmailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>> = ({ signal }) => shopsControllerGetOrGenerateReservationEmail(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerGetOrGenerateReservationEmailQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>>
export type ShopsControllerGetOrGenerateReservationEmailQueryError = unknown


export function useShopsControllerGetOrGenerateReservationEmail<TData = Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetOrGenerateReservationEmail<TData = Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetOrGenerateReservationEmail<TData = Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerGetOrGenerateReservationEmail<TData = Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetOrGenerateReservationEmail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerGetOrGenerateReservationEmailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerGetConfirmationEmailStatus = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConfirmationEmailStatusDto>(
      {url: `/shops/${id}/confirmation-email`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerGetConfirmationEmailStatusQueryKey = (id?: string,) => {
    return [
    `/shops/${id}/confirmation-email`
    ] as const;
    }

    
export const getShopsControllerGetConfirmationEmailStatusQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerGetConfirmationEmailStatusQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>> = ({ signal }) => shopsControllerGetConfirmationEmailStatus(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerGetConfirmationEmailStatusQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>>
export type ShopsControllerGetConfirmationEmailStatusQueryError = unknown


export function useShopsControllerGetConfirmationEmailStatus<TData = Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetConfirmationEmailStatus<TData = Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetConfirmationEmailStatus<TData = Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerGetConfirmationEmailStatus<TData = Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetConfirmationEmailStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerGetConfirmationEmailStatusQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerMarkConfirmationInitiated = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConfirmationEmailStatusDto>(
      {url: `/shops/${id}/confirmation-email/initiate`, method: 'POST', signal
    },
      );
    }
  


export const getShopsControllerMarkConfirmationInitiatedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerMarkConfirmationInitiated>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerMarkConfirmationInitiated>>, TError,{id: string}, TContext> => {

const mutationKey = ['shopsControllerMarkConfirmationInitiated'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerMarkConfirmationInitiated>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  shopsControllerMarkConfirmationInitiated(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerMarkConfirmationInitiatedMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerMarkConfirmationInitiated>>>
    
    export type ShopsControllerMarkConfirmationInitiatedMutationError = unknown

    export const useShopsControllerMarkConfirmationInitiated = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerMarkConfirmationInitiated>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerMarkConfirmationInitiated>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getShopsControllerMarkConfirmationInitiatedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const shopsControllerSaveCredentials = (
    id: string,
    saveCredentialsDto: SaveCredentialsDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}/credentials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveCredentialsDto, signal
    },
      );
    }
  


export const getShopsControllerSaveCredentialsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerSaveCredentials>>, TError,{id: string;data: SaveCredentialsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerSaveCredentials>>, TError,{id: string;data: SaveCredentialsDto}, TContext> => {

const mutationKey = ['shopsControllerSaveCredentials'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerSaveCredentials>>, {id: string;data: SaveCredentialsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  shopsControllerSaveCredentials(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerSaveCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerSaveCredentials>>>
    export type ShopsControllerSaveCredentialsMutationBody = SaveCredentialsDto
    export type ShopsControllerSaveCredentialsMutationError = unknown

    export const useShopsControllerSaveCredentials = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerSaveCredentials>>, TError,{id: string;data: SaveCredentialsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerSaveCredentials>>,
        TError,
        {id: string;data: SaveCredentialsDto},
        TContext
      > => {

      const mutationOptions = getShopsControllerSaveCredentialsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const shopsControllerGetCredentialsStatus = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}/credentials`, method: 'GET', signal
    },
      );
    }
  



export const getShopsControllerGetCredentialsStatusQueryKey = (id?: string,) => {
    return [
    `/shops/${id}/credentials`
    ] as const;
    }

    
export const getShopsControllerGetCredentialsStatusQueryOptions = <TData = Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopsControllerGetCredentialsStatusQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>> = ({ signal }) => shopsControllerGetCredentialsStatus(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopsControllerGetCredentialsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>>
export type ShopsControllerGetCredentialsStatusQueryError = unknown


export function useShopsControllerGetCredentialsStatus<TData = Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetCredentialsStatus<TData = Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>,
          TError,
          Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopsControllerGetCredentialsStatus<TData = Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopsControllerGetCredentialsStatus<TData = Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopsControllerGetCredentialsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopsControllerGetCredentialsStatusQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopsControllerTestCredentials = (
    id: string,
    testCredentialsDto: TestCredentialsDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/shops/${id}/credentials/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testCredentialsDto, signal
    },
      );
    }
  


export const getShopsControllerTestCredentialsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerTestCredentials>>, TError,{id: string;data: TestCredentialsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shopsControllerTestCredentials>>, TError,{id: string;data: TestCredentialsDto}, TContext> => {

const mutationKey = ['shopsControllerTestCredentials'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopsControllerTestCredentials>>, {id: string;data: TestCredentialsDto}> = (props) => {
          const {id,data} = props ?? {};

          return  shopsControllerTestCredentials(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopsControllerTestCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof shopsControllerTestCredentials>>>
    export type ShopsControllerTestCredentialsMutationBody = TestCredentialsDto
    export type ShopsControllerTestCredentialsMutationError = unknown

    export const useShopsControllerTestCredentials = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopsControllerTestCredentials>>, TError,{id: string;data: TestCredentialsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopsControllerTestCredentials>>,
        TError,
        {id: string;data: TestCredentialsDto},
        TContext
      > => {

      const mutationOptions = getShopsControllerTestCredentialsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    